require('./dataGrid.styles');
import { IDictionary } from 'util/domain/standard-types';

export interface DataGridConfig<T, U> {
	transformRows:(rows:T[]) => DataGridRow<U>[];
	transformColumns:(columns:string[]) => DataGridColumn[];
	link:(row:T) => void;
	filterPhrase:string;
	iconSet?:IconSet;
}

export interface DataGridRow<T> {
	[prop:string]:T;
}

export interface DataGridColumn {
	displayName:string;
	propName:string;
	dataType:string;
}

export interface IconSet {
	[prop:string]: {
		[value:string]:string;
	}
}

export class DataGridController<T, U> implements ng.IComponentController {
	constructor (
		private $locale:ng.ILocaleService
	) {
		this.rows = this.config.transformRows(this.items);
		this.columns = this.config.transformColumns(Object.keys(this.items[0]));
		this.order = this.columns[0].propName;
		this.columnPropNames = this.columns.map(column => column.propName);
		}

	public config:DataGridConfig<T, U>;
	public rows:DataGridRow<U>[];
	public items:T[];
	public icons:IconSet = this.config.iconSet;
	public columns:DataGridColumn[];
	public columnPropNames:string[];
	public order:string;
	
	public get filterData() {
		return {
			filterPhrase: this.config.filterPhrase,
			columns: this.columns,
			icons: this.icons
		}
	}

	public getIcon(column:string, value:string) {
		return this.icons[column][value];
	}

	public display(cell:any) {
		// https://regex101.com/r/zsJsaq/3
		const dateRegex = /\d{4}-\d{2}-\d{2}(\s|T)\d{2}:\d{2}:\d{2}Z?/gi;
		if (dateRegex.test(cell)) {
			if (new Date(cell).getFullYear() > 9000) {
				return null;
			}
			else {
				return this.formatDate(cell);
			}
		}
		// transform arrays into comma-separated format
		if (Array.isArray(cell)) {
			return cell.join(', ');
		}
		else {
			return cell;
		}
	}

	private formatDate(date:string) {
		let dateTimeOptions:Intl.DateTimeFormatOptions = {
			year: 'numeric',
			month: 'numeric',
			day: 'numeric'
		};

		let activityFormat = new Intl.DateTimeFormat(this.$locale.id, dateTimeOptions);
		return activityFormat.format(new Date(date));
	}
}

const template = require('./dataGrid.template');
export const DataGridComponent:ng.IComponentOptions = {
	template,
	controller: DataGridController,
	controllerAs: 'vm',
	bindings: {
		items: '<',
		config: '<'
	}
};

DataGridController.$inject = [
	'$locale'
];



// WEBPACK FOOTER //
// ./src/sharebase/components/dataGrid/dataGrid.ts